import OnboardingShopName from "~/components/onboarding/OnboardingShopName";
import OnboardingDomain from "~/components/onboarding/OnboardingDomain";
import OnboardingLogo from "~/components/onboarding/OnboardingLogo";
import OnboardingShopRegion from "~/components/onboarding/OnboardingShopRegion";
import OnboardingShopCreation from "~/components/onboarding/OnboardingShopCreation";

const NAME = "name";
const DOMAIN = "domain";
const LOGO = "logo";
const REGION = "region";
const SHOP_CREATION = "shop_creation";

export default class OnboardingGraph {
  constructor() {
    this.adjacencyList = new Map();

    this.adjacencyList.set(NAME, { parent: null, children: [DOMAIN] });
    this.adjacencyList.set(DOMAIN, { parent: NAME, children: [LOGO] });
    this.adjacencyList.set(LOGO, {
      parent: DOMAIN,
      children: [REGION],
    });
    this.adjacencyList.set(REGION, { parent: LOGO, children: [SHOP_CREATION] });
    this.adjacencyList.set(SHOP_CREATION, {
      parent: REGION,
      children: null,
    });
  }

  // Returns the first step of the onboarding
  firstStep() {
    return NAME;
  }

  // Given a current step, returns the next one.
  // Please note that some steps may have more than one branches (eg: Payment Method)
  // If there is more than one child, please use the second argument of this function to specify wich one do you prefer
  nextStep(step, preferredChild) {
    if (this.adjacencyList.has(step)) {
      let children = this.adjacencyList.get(step).children;

      if (!children) return null;
      if (children.length === 1) return children[0];

      if (
        preferredChild !== null &&
        typeof preferredChild !== "undefined" &&
        preferredChild >= 0
      )
        return children[preferredChild];
      else {
        console.error(
          "There is more than one possible next step; Please use the functions' second argument to specify which one you prefer"
        );
      }
    } else {
      console.error(
        "Next step requested -> " +
          step +
          " is not a valid step; Please make sure that you are using one of the steps defined in OnboardingGraph"
      );
    }
  }

  // Given a current step, returns the previous one.
  // May be null if it is the root step.
  previousStep(step) {
    if (this.adjacencyList.has(step)) {
      return this.adjacencyList.get(step).parent;
    } else {
      console.error(
        "Previous step requested -> " +
          step +
          " is not a valid step; Please make sure that you are using one of the steps defined in OnboardingGraph"
      );
    }
  }

  // Prints the graph on the console.
  print() {
    console.log(this.adjacencyList);
  }

  // Given a step, returns the React component for it.
  // Accepts optional props to pass down to the rendered component.
  render(step, props) {
    switch (step) {
      case NAME:
        return <OnboardingShopName {...props} />;
      case DOMAIN:
        return <OnboardingDomain {...props} />;
      case LOGO:
        return <OnboardingLogo {...props} />;
      case REGION:
        return <OnboardingShopRegion {...props} />;
      case SHOP_CREATION:
        return <OnboardingShopCreation {...props} />;
      default:
        console.error(
          "Step render requested -> " +
            step +
            " is not a valid step; Please make sure that you are using one of the steps defined in OnboardingGraph"
        );
    }
  }

  // Given a step, returns the step number (1 = first step, 2 = second step, etc...)
  // Useful in combination with the Stepper component
  stepNumber(step) {
    switch (step) {
      case NAME:
        return 1;
      case DOMAIN:
        return 2;
      case LOGO:
        return 3;
      case REGION:
        return 4;
      case SHOP_CREATION:
        return 5;
      default:
        console.error(
          "Step number requested -> " +
            step +
            " is not a valid step; Please make sure that you are using one of the steps defined in OnboardingGraph"
        );
    }
  }

  isLastStep(step) {
    if (this.adjacencyList.has(step)) {
      return this.adjacencyList.get(step).children === null;
    } else {
      console.error(
        "Is last step requested -> " +
          step +
          " is not a valid step; Please make sure that you are using one of the steps defined in OnboardingGraph"
      );
    }
  }
}
